import * as React from "react";

function SvgComponent(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.463 1.587v7.537H24V1.587h-7.537zm1.256 1.256h5.025v5.025h-5.025V2.843zm1.256 1.256v2.513h2.513V4.099h-2.513zM3.77 5.355V8.53h3.376c2.142 0 3.358 1.04 3.358 2.939 0 1.947-1.216 3.011-3.358 3.011H3.769l.001-5.95H0v13.884h3.769v-4.76h3.57c4.333 0 6.815-2.352 6.815-6.32 0-3.771-2.482-5.978-6.814-5.978l-3.57-.001z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComponent;
